import { render, staticRenderFns } from "./workload-course-equivalents.vue?vue&type=template&id=5845f771&"
import script from "./workload-course-equivalents.vue?vue&type=script&lang=js&"
export * from "./workload-course-equivalents.vue?vue&type=script&lang=js&"
import style0 from "./workload-course-equivalents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports